import { mockTelegramEnv, retrieveLaunchParams } from "@telegram-apps/sdk";

// Use Vite's built-in DEV flag which is always correctly set
const IS_DEV = import.meta.env.DEV;

// In development, always mock the Telegram environment unless we can confirm we're actually in Telegram
// Temprary to make it work
if (true || IS_DEV) {
  let shouldMock = true;

  // Only try to check if we're in Telegram if we're in a browser environment
  if (typeof window !== "undefined") {
    try {
      // Try to retrieve launch params - if successful, we might be in Telegram
      retrieveLaunchParams();
      shouldMock = false;
    } catch (e) {
      shouldMock = true;
    }

    // Double check - if we have a previous mock flag in session storage, use that
    if (sessionStorage.getItem("____mocked")) {
      shouldMock = true;
    }
  }

  if (shouldMock) {
    try {
      const initDataRaw = new URLSearchParams([
        [
          "user",
          JSON.stringify({
            id: 99281932,
            first_name: "Andrew",
            last_name: "Rogue",
            username: "rogue",
            language_code: "ru",
            is_premium: true,
            allows_write_to_pm: true,
          }),
        ],
        [
          "hash",
          "89d6079ad6762351f38c6dbbc41bb53048019256a9443988af7a48bcad16ba31",
        ],
        ["auth_date", "1716922846"],
        ["start_param", "debug"],
        ["chat_type", "sender"],
        ["chat_instance", "8428209589180549439"],
        ["signature", "6fbdaab833d39f54518bd5c3eb3f511d035e68cb"],
      ]).toString();

      // Mock using a proper query string format
      mockTelegramEnv({
        launchParams: {
          tgWebAppThemeParams: {
            accent_text_color: "#6ab2f2",
            bg_color: "#17212b",
            button_color: "#5288c1",
            button_text_color: "#ffffff",
            destructive_text_color: "#ec3942",
            header_bg_color: "#17212b",
            hint_color: "#708499",
            link_color: "#6ab3f3",
            secondary_bg_color: "#232e3c",
            section_bg_color: "#17212b",
            section_header_text_color: "#6ab3f3",
            subtitle_text_color: "#708499",
            text_color: "#f5f5f5",
          },
          tgWebAppData: initDataRaw,
          tgWebAppVersion: "8",
          tgWebAppPlatform: "tdesktop",
        },
      });

      // Mark that we've mocked the environment
      sessionStorage.setItem("____mocked", "1");
    } catch (error) {
      console.error("Failed to set up mock environment:", error);
    }
  }
}
